const HeaderBottomTracker = (() => {
  let headerEl = null;
  let rafId = 0;
  let listening = false;
  let pointerInMenu = false;

  function header() {
    if (!headerEl || !headerEl.isConnected) headerEl = document.querySelector('.header-wrapper');
    return headerEl;
  }

  function write() {
    rafId = 0;
    const h = header();
    if (!h) return;
    const next = `${Math.max(0, Math.round(h.getBoundingClientRect().bottom))}px`;
    const root = document.documentElement;
    if (root.style.getPropertyValue('--header-bottom-position-desktop') !== next) {
      root.style.setProperty('--header-bottom-position-desktop', next);
    }
  }

  function schedule() {
    if (rafId) return;
    rafId = requestAnimationFrame(write);
  }

  function anyOpen() {
    return !!document.querySelector('header-menu details[open]');
  }

  function listen(on) {
    if (on === listening) return;
    listening = on;
    if (on) {
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
    } else {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
    }
  }

  function sync() {
    listen(pointerInMenu || anyOpen());
  }

  function bindMenu() {
    const nav = document.querySelector('.header__inline-menu');
    if (!nav || nav.dataset.headerBottomBound === '1') return;
    nav.dataset.headerBottomBound = '1';
    nav.addEventListener('pointerenter', () => {
      pointerInMenu = true;
      write();
      sync();
    }, { passive: true });
    nav.addEventListener('pointerleave', () => {
      pointerInMenu = false;
      sync();
    }, { passive: true });
    nav.addEventListener('focusin', () => {
      write();
      sync();
    });
    nav.addEventListener('focusout', () => {
      sync();
    });
  }

  return { write, schedule, sync, bindMenu, anyOpen };
})();

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) return;
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {}

  close() {
    if (!this.mainDetailsToggle || !this.mainDetailsToggle.hasAttribute('open')) return;
    this.mainDetailsToggle.removeAttribute('open');
    const li = this.closest('li');
    if (li) li.classList.remove('mega-menu-active');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    HeaderBottomTracker.bindMenu();
    HeaderBottomTracker.schedule();
  }

  onToggle() {
    const isOpen = this.mainDetailsToggle.hasAttribute('open');
    const summary = this.mainDetailsToggle.querySelector('summary');
    const expanded = isOpen ? 'true' : 'false';
    if (summary && summary.getAttribute('aria-expanded') !== expanded) summary.setAttribute('aria-expanded', expanded);
    if (!this.header) return;
    this.header.preventHide = HeaderBottomTracker.anyOpen();
    if (isOpen) HeaderBottomTracker.write();
    HeaderBottomTracker.sync();
  }
}

customElements.define('header-menu', HeaderMenu);

/* V3.2 menu asset ownership:
   - Desktop keeps the approved V2.8 visual stack, then removes the duplicated
     Heated Tobacco standalone help row only after the Buying Guide card exists.
   - Mobile loads one consolidated V3.0 enhancer only; Brands uses its native
     Top Vape Brands tree plus four rich commercial offer cards, without a second logo grid. */
(() => {
  const current = document.currentScript;
  if (!current || !current.src) return;

  const atBootDesktop = window.matchMedia('(min-width: 990px)').matches;
  let started = false;

  function addStyle(filename) {
    const css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = new URL(filename, current.src).href;
    document.head.appendChild(css);
  }

  function addScript(filename, onload) {
    const script = document.createElement('script');
    script.src = new URL(filename, current.src).href;
    if (onload) script.onload = onload;
    document.head.appendChild(script);
  }

  function bootDesktop() {
    if (started) return;
    started = true;
    addStyle('menu-desktop.css?v=bd00391ac2a616cb');
    addScript('menu-desktop.js?v=3b14284023f1ed58');
  }

  function bootMobile() {
    if (started) return;
    started = true;
    addStyle('v30-mobile-menu.css?v=320');
    addScript('v30-mobile-menu.js?v=320');
  }

  if (atBootDesktop) bootDesktop();
  else bootMobile();

  /* Legacy desktop menu scripts contain historical mobile media listeners.
     Crossing the 990px breakpoint in the same document could therefore activate
     code that is intentionally excluded from V3.2 mobile. A one-time reload on
     an actual breakpoint crossing preserves single ownership. Normal phone
     orientation changes remain below 990px and do not reload. */
  const breakpoint = window.matchMedia('(min-width: 990px)');
  breakpoint.addEventListener?.('change', (event) => {
    if (event.matches !== atBootDesktop) window.location.reload();
  }, { once: true });
})();
